// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GA4 Integration Page */

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-row {
  display: flex;
  gap: 20px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content {
  width: 612px;
  flex-shrink: 0;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card {
  height: 100%;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner {
  padding: 16px;
  height: 100%;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner.card-inner--column {
  display: flex;
  flex-direction: column;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner .BC-Switch-Status {
  height: 16px;
  width: 34px;
  margin-right: 8px;
  display: inline-flex;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {
  width: 34px;
  height: 16px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {
  width: 16px;
  height: 16px;
  transform: translateX(0);
}

.BC-Page.BC-Page__GA4Integration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

.BC-Page.BC-Page__GA4Integration .BC-Page__Title--Help {
  padding-left: 53px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .divider {
  border: 1px solid #E1E3E5;
  margin-bottom: 24px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .card-inner--center {
  text-align: center;
  padding-bottom: 20px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event {
  border: 1px solid #E1E3E5;
  border-radius: 8px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__toggle {
  background-color: #FAFBFB;
  padding: 12px 16px;
  display: flex;
  gap: 4px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-wrapper:first-child .ga4-event-collapse__toggle {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-wrapper:last-child .ga4-event-collapse__toggle {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: 0;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content {
  padding: 12px 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  border-bottom: 1px solid #E1E3E5;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content .ga4-event-collapse__content__title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-basis: 50%;
  padding-left: 24px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content p {
  flex-basis: 50%;
  text-align: left;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-section-title {
  margin-bottom: 4px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-toggle-help-text {
  padding-left: 42px;
  margin-top: 4px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-text-content {
  text-align: left;
  margin-bottom: 16px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content__title p {
  flex-basis: auto;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content__child-description {
  margin: 0;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .guide {
  margin-bottom: 8px;
  margin-top: 16px;
  text-align: left;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-guide-note {
  margin: 0;
  margin-top: 16px;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .guide .Polaris-Link {
  display: inline-flex;
  align-items: center;
  text-decoration: underline;
}

.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .guide .Polaris-Link .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
  margin-left: 2px;
}

.callback-ga4 {
  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;
  background-color: #fff;
  border-radius: 8px;
  padding: 40px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.callback-ga4 .callback-ga4__title {
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 24px;
}

/* GA4 Account Info */
.BC-Page.BC-Page__GA4Integration .ga4-account-info {
  margin-top: 8px;
  padding-left: 42px;
}

.BC-Page.BC-Page__GA4Integration .ga4-account-info__row {
  display: flex;
  align-items: center;
}

.BC-Page.BC-Page__GA4Integration .ga4-account-info__row:not(:last-child) {
  margin-bottom: 4px;
}

.BC-Page.BC-Page__GA4Integration .ga4-account-info__label {
  width: 220px;
  flex-shrink: 0;
  color: #6d7175;
  font-size: 14px;
  line-height: 20px;
}

.BC-Page.BC-Page__GA4Integration .ga4-account-info__value {
  font-size: 14px;
  line-height: 20px;
  color: #202223;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.BC-Page.BC-Page__GA4Integration .ga4-account-info__copy {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.BC-Page.BC-Page__GA4Integration .ga4-account-info__copy .Polaris-Icon {
  width: 16px;
  height: 16px;
}

/* GA4 Property Selector */
.BC-Page.BC-Page__GA4Integration .ga4-property-selector {
  margin-top: 16px;
}

.BC-Page.BC-Page__GA4Integration .ga4-property-selector__content {
  margin-bottom: 12px;
}

.BC-Page.BC-Page__GA4Integration .ga4-property-selector__banner {
  margin-bottom: 12px;
}

.BC-Page.BC-Page__GA4Integration .ga4-property-selector__select-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.BC-Page.BC-Page__GA4Integration .ga4-property-selector__label {
  flex-shrink: 0;
  width: 220px;
  font-size: 14px;
  line-height: 20px;
  color: #6d7175;
}

.BC-Page.BC-Page__GA4Integration .ga4-property-selector__select {
  flex: 1;
  min-width: 200px;
}

.BC-Page.BC-Page__GA4Integration .ga4-property-selector__action {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/styles/ga4-integration.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iEAAiE;EACjE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":["/* GA4 Integration Page */\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-row {\n  display: flex;\n  gap: 20px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content {\n  width: 612px;\n  flex-shrink: 0;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card {\n  height: 100%;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner {\n  padding: 16px;\n  height: 100%;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner.card-inner--column {\n  display: flex;\n  flex-direction: column;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner .BC-Switch-Status {\n  height: 16px;\n  width: 34px;\n  margin-right: 8px;\n  display: inline-flex;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner .BC-Switch-Status__Bar {\n  width: 34px;\n  height: 16px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .Polaris-Card .card-inner .BC-Switch-Status__Dot {\n  width: 16px;\n  height: 16px;\n  transform: translateX(0);\n}\n\n.BC-Page.BC-Page__GA4Integration .BC-Switch-Status input:checked+.BC-Switch-Status__Bar .BC-Switch-Status__Dot {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n.BC-Page.BC-Page__GA4Integration .BC-Page__Title--Help {\n  padding-left: 53px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .divider {\n  border: 1px solid #E1E3E5;\n  margin-bottom: 24px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .card-inner--center {\n  text-align: center;\n  padding-bottom: 20px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event {\n  border: 1px solid #E1E3E5;\n  border-radius: 8px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__toggle {\n  background-color: #FAFBFB;\n  padding: 12px 16px;\n  display: flex;\n  gap: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-wrapper:first-child .ga4-event-collapse__toggle {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-wrapper:last-child .ga4-event-collapse__toggle {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-bottom: 0;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content {\n  padding: 12px 16px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  border-bottom: 1px solid #E1E3E5;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content .ga4-event-collapse__content__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-basis: 50%;\n  padding-left: 24px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content p {\n  flex-basis: 50%;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-section-title {\n  margin-bottom: 4px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-toggle-help-text {\n  padding-left: 42px;\n  margin-top: 4px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-text-content {\n  text-align: left;\n  margin-bottom: 16px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content__title p {\n  flex-basis: auto;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-event .ga4-event-collapse__content__child-description {\n  margin: 0;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .guide {\n  margin-bottom: 8px;\n  margin-top: 16px;\n  text-align: left;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .ga4-guide-note {\n  margin: 0;\n  margin-top: 16px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .guide .Polaris-Link {\n  display: inline-flex;\n  align-items: center;\n  text-decoration: underline;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-container .ga4-col-content .guide .Polaris-Link .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  margin-left: 2px;\n}\n\n.callback-ga4 {\n  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 40px 48px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.callback-ga4 .callback-ga4__title {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 32px;\n  text-align: center;\n  margin-top: 12px;\n  margin-bottom: 24px;\n}\n\n/* GA4 Account Info */\n.BC-Page.BC-Page__GA4Integration .ga4-account-info {\n  margin-top: 8px;\n  padding-left: 42px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-account-info__row {\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-account-info__row:not(:last-child) {\n  margin-bottom: 4px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-account-info__label {\n  width: 220px;\n  flex-shrink: 0;\n  color: #6d7175;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-account-info__value {\n  font-size: 14px;\n  line-height: 20px;\n  color: #202223;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-account-info__copy {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-account-info__copy .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* GA4 Property Selector */\n.BC-Page.BC-Page__GA4Integration .ga4-property-selector {\n  margin-top: 16px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-property-selector__content {\n  margin-bottom: 12px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-property-selector__banner {\n  margin-bottom: 12px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-property-selector__select-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-property-selector__label {\n  flex-shrink: 0;\n  width: 220px;\n  font-size: 14px;\n  line-height: 20px;\n  color: #6d7175;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-property-selector__select {\n  flex: 1;\n  min-width: 200px;\n}\n\n.BC-Page.BC-Page__GA4Integration .ga4-property-selector__action {\n  margin-top: 12px;\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
